(function () {
    'use strict';
    angular.module('Filters').filter('bbaCamelCaseToTextSentenceCase', bbaCamelCaseToTextSentenceCase);

    bbaCamelCaseToTextSentenceCase.$inject = [];

    function bbaCamelCaseToTextSentenceCase() {
        return function (text) {
            const partialText = text.replace( /([A-Z])/g, " $1" );
            return partialText.charAt(0).toUpperCase()  + partialText.slice(1);
        }
    }
})()



// WEBPACK FOOTER //
// ./js/filters/bbaCamelCaseToTextSentenceCase.js